import store from '@/store';
import { perfioDocumentRepository } from '../repository-factory';
import getBase64 from '@/lib/helpers/get-base-64';
import uploadApiCall from '@/lib/helpers/upload-call-api';
import callApi from '@/lib/helpers/call-api';
import PERFIOS_TRANSACTION from '@/lib/constants/store';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';

const getUploadPayload = () => {
  const { appId, statementTwoData } = store.state;
  const { values } = store.state.formData;

  const {
    duniaIncomeVerificationId,
    vendorIncomeVerificationId,
  } = store.state.formData[PERFIOS_TRANSACTION];
  var password = "";
  if (getValueByFieldName(values, FIELD_NAMES.payslipTwoPassword)) {
    password = getValueByFieldName(values, FIELD_NAMES.payslipTwoPassword);
  }
  else {
    password = "";
  }
  return {
    'app-id': appId,
    'dunia-income-verification-id': duniaIncomeVerificationId,
    'vendor-income-verification-id': vendorIncomeVerificationId,
    'password': password,
    'file': {
      doctype: 'income-verification',
      ext: 'pdf',
      content: statementTwoData, //await getBase64(file),
    },
  };
};

export default {
  async sendBankStatement(currentStep, callbacks) {
    const { form } = currentStep;
    const response = await callApi({
      // ,
      callbacks,
      form,
      formElement: currentStep,
      apiCall: perfioDocumentRepository.sendBankStatement,
      payload: getUploadPayload(),
    });
    if(response)
    {
      return response;
    }
  },
};
